import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
// Components
import { XmarkRegular } from '../../assets/icons/iconComponents';
// Styles
import styles from './modal.module.css';

export default function Modal({
  children,
  customStyles,
  handleClose,
  fullScreen = true,
  showClose = false,
}) {
  const [isBrowser, setIsBrowser] = useState(false);

  const modalHeightOnMobile = !fullScreen ? styles.partialScreen : '';

  useEffect(() => {
    if (window) setIsBrowser(true);
  }, []);

  const modalContent = (
    <div className={styles.modalOverlay}>
      <div
        className={`${styles.modalWrapper} ${modalHeightOnMobile}`}
        style={customStyles}
      >
        {showClose ? (
          <button
            className={styles.modalCloseButton}
            onClick={() => handleClose()}
            data-core-qa="modalCloseButton"
          >
            <XmarkRegular className={styles.closeIcon} />
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );

  if (isBrowser) {
    return ReactDOM.createPortal(modalContent, document.getElementById('modal-root'));
  } else {
    return null;
  }
}
